import { ErrorMessage, ErrorRoot, ErrorTitle, RetryButton } from './styled';
import type { ErrorStateProps } from './types';

const DEFAULT_MESSAGE = 'Error fetching drug test reports';

const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
  <ErrorRoot role="alert">
    <ErrorTitle>Unable to load drug test reports</ErrorTitle>
    <ErrorMessage>{message?.trim() || DEFAULT_MESSAGE}</ErrorMessage>
    {onRetry ? (
      <RetryButton variant="outlined" size="small" onClick={onRetry}>
        Retry
      </RetryButton>
    ) : null}
  </ErrorRoot>
);

export default ErrorState;
